/**
 * Load the source for Smart Suspense WebComponent, which is used in the Smart Suspense panel
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadSmartSuspenseScript(document: Document) {
  const now = Date.now()
  const jsPath = '/plugin/smart-suspense-ui/smart-suspense.js'
  const script = document.getElementById('smartSuspenseUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
